import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export const BgImag = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    return (
        <motion.img
            initial={{ x: "100vw", opacity: 0, scaleX: -1 }}
            animate={{
                x: 0,
                opacity: isMobile ? 0.3 : 1,
                scaleX: -1,
            }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            src="/img/arara-verde.png"
            alt="Arara"
            className={`
        block absolute top-[-2rem] 
        ${isMobile ? "left-12" : "md:top-[-4.9rem] md:right-0 md:left-auto"}
        w-full max-w-[28rem] 
        md:max-w-none md:w-[63.75rem] 
        h-auto md:h-[92rem]
        pointer-events-none z-0
      `}
        />
    );
};
